import { render, staticRenderFns } from "./LugarUbicacion.vue?vue&type=template&id=8a1837b8"
import script from "./LugarUbicacion.vue?vue&type=script&lang=js"
export * from "./LugarUbicacion.vue?vue&type=script&lang=js"
import style0 from "./LugarUbicacion.vue?vue&type=style&index=0&id=8a1837b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports